import { render, staticRenderFns } from "./SwapQuestion.vue?vue&type=template&id=3f9cec58&"
import script from "./SwapQuestion.vue?vue&type=script&lang=js&"
export * from "./SwapQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports